import {
  GRIDEABLE_REQUEST,
  GRIDEABLE_SUCCESS,
  GRIDEABLE_SET_SEARCH_FIELDS,
  GRIDEABLE_FAILURE,
  GRIDEABLE_SET_ORDER, GRIDEABLE_SET_TIENDA_ID_FILTER, GRIDEABLE_INIT,
} from '../constants/grideable.constants';


export const gridInit = ({ endpoint }) => ({
  type: GRIDEABLE_INIT,
  payload: { endpoint },
});

export const gridRequestAction = (payload) => ({
  type: GRIDEABLE_REQUEST,
  payload,
});

export const gridSuccessAction = ({ endpoint, datos, pagination }) => ({
  type: GRIDEABLE_SUCCESS,
  payload: { endpoint, datos, pagination },
});

export const gridFailureAction = ({ endpoint }) => ({
  type: GRIDEABLE_FAILURE,
  payload: { endpoint },
});

export const gridSetFilterAction = ({endpoint, filters}) => ({
  type: GRIDEABLE_SET_SEARCH_FIELDS,
  payload: {
    endpoint, filters,
  },
});

export const gridSetTiendaFilterAction = ({endpoint, tiendaId}) => ({
  type: GRIDEABLE_SET_TIENDA_ID_FILTER,
  payload: {
    endpoint, tiendaId,
  },
});

export const gridSetOrder = ({ endpoint, order }) => ({
  type: GRIDEABLE_SET_ORDER,
  payload: {
    endpoint, order,
  },
});
